export const BASE_URL = process.env.REACT_APP_API_URL || 'https://wq.lms-school.ru'

export const MAX_RETRIES = 4

export const BASE_PARAMS = {
  action: 'consolidated',
  format: 'json',
  base: 'cons',
}
